(() => {
  const frameId = 'automizely_marketing_popup_bars';
  const styleId = 'vh-aftership-mobile-image';
  const configuredImageUrl = document.currentScript?.dataset.layoutImageUrl?.trim() || '';
  let layoutImageUrl = '';
  try {
    const imageUrl = new URL(configuredImageUrl, window.location.href);
    if (imageUrl.protocol === 'https:' || imageUrl.protocol === 'http:') {
      layoutImageUrl = imageUrl.href;
    }
  } catch {
    // Leave the mobile image empty when the theme setting is not a valid URL.
  }
  const layoutImageCss = layoutImageUrl ? `url(${JSON.stringify(layoutImageUrl)})` : 'none';
  const observedFrames = new WeakSet();
  const observedDocuments = new WeakSet();
  const originalDialogSizes = new WeakMap();

  const desktopStyles = `
    @media (min-width: 768px) {
      .MuiDialog-container {
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
      }

      .MuiPaper-root {
        --vh-popup-unit: min(0.052083333vw, 0.108813928vh);
        position: relative !important;
        box-sizing: border-box !important;
        width: min(40.625vw, 156vh) !important;
        max-width: none !important;
        max-height: 84vh !important;
        aspect-ratio: 13 / 7 !important;
        margin: 0 !important;
        padding: 0 !important;
        overflow: hidden !important;
        border-radius: 0 !important;
        background: #fff !important;
        font-size: min(0.833333vw, 1.741vh) !important;
      }

      .MuiPaper-root::before {
        content: "";
        position: absolute;
        inset: 0 auto 0 0;
        z-index: 0;
        width: 47.7%;
        background: ${layoutImageCss} center / cover no-repeat;
      }

      .MuiPaper-root .MuiDialogTitle-root {
        position: absolute !important;
        top: calc(8 * var(--vh-popup-unit)) !important;
        right: calc(8 * var(--vh-popup-unit)) !important;
        z-index: 3 !important;
        box-sizing: border-box !important;
        width: calc(44 * var(--vh-popup-unit)) !important;
        height: calc(44 * var(--vh-popup-unit)) !important;
        padding: 0 !important;
        font-size: inherit !important;
        pointer-events: none !important;
      }

      .MuiPaper-root .MuiDialogTitle-root .MuiIconButton-root {
        position: absolute !important;
        inset: 0 !important;
        width: 100% !important;
        height: 100% !important;
        padding: 0 !important;
        border: 0 !important;
        border-radius: 50% !important;
        background: transparent !important;
        color: #a6a6a6 !important;
        font-size: inherit !important;
        pointer-events: auto !important;
        touch-action: manipulation !important;
        cursor: pointer !important;
      }

      .MuiPaper-root .MuiDialogTitle-root .MuiIconButton-root::before {
        content: "";
        position: absolute;
        inset: calc(7 * var(--vh-popup-unit));
        box-sizing: border-box;
        border: 1px solid #a6a6a6;
        border-radius: 50%;
        background: #fff;
        pointer-events: none;
      }

      .MuiPaper-root .MuiDialogTitle-root .MuiIconButton-root svg {
        position: relative !important;
        width: calc(16 * var(--vh-popup-unit)) !important;
        height: calc(16 * var(--vh-popup-unit)) !important;
        stroke-width: 1.25 !important;
      }

      .MuiPaper-root .MuiDialogContent-root > .customModalBg[style*="background-image"] {
        display: none !important;
      }

      .MuiPaper-root .MuiDialogContent-root > .customModalBg:not([style*="background-image"]) {
        position: absolute !important;
        inset: 0 0 0 auto !important;
        z-index: 1 !important;
        display: flex !important;
        box-sizing: border-box !important;
        flex-direction: column !important;
        justify-content: center !important;
        width: 52.3% !important;
        height: 100% !important;
        padding: 0 15px !important;
        overflow: auto !important;
        background: #fff !important;
        background-image: none !important;
        font-size: calc(14 * var(--vh-popup-unit)) !important;
      }

      .MuiPaper-root .MuiDialogContent-root > .customModalBg:not([style*="background-image"]) > div {
        box-sizing: border-box !important;
        container-type: inline-size;
        width: 100% !important;
        min-width: 0 !important;
        margin: 0 !important;
        padding: 0 !important;
      }

      .MuiPaper-root .customModalBg div:has(> .mars-stack-item) {
        width: 100% !important;
        margin: 0 !important;
        gap: calc(16 * var(--vh-popup-unit)) !important;
      }

      .MuiPaper-root .customModalBg .mars-stack-item {
        box-sizing: border-box !important;
        width: 100% !important;
        min-width: 0 !important;
        margin: 0 !important;
      }

      .MuiPaper-root .customModalBg * {
        font-size: inherit !important;
        line-height: 1.25 !important;
      }

      .MuiPaper-root .customModalBg div:has(> span[style*="margin-bottom"]) {
        box-sizing: border-box !important;
        width: 100% !important;
        margin: 0 0 calc(12 * var(--vh-popup-unit)) !important;
        padding: 0 !important;
      }

      .MuiPaper-root .customModalBg div:has(> span[style*="margin-bottom"]) > span {
        color: #111 !important;
        margin-bottom: 0 !important;
        font-size: min(calc(18 * var(--vh-popup-unit)), 4.8cqw) !important;
        font-weight: 400 !important;
        line-height: 1.25 !important;
        letter-spacing: -0.01em !important;
        text-align: left !important;
        white-space: nowrap !important;
      }

      .MuiPaper-root .customModalBg :is(h1, h2, h3, h4, .MuiTypography-h4, .MuiTypography-h5) {
        font-size: calc(18 * var(--vh-popup-unit)) !important;
        line-height: 1.25 !important;
      }

      .MuiPaper-root .customModalBg span[style*="white-space: pre-line"]:not([style*="margin-bottom"]) {
        display: block !important;
        width: 100% !important;
        margin-right: 0 !important;
        margin-left: 0 !important;
        font-size: inherit !important;
        line-height: 1.25 !important;
        text-align: left !important;
      }

      .MuiPaper-root .MuiTypography-root,
      .MuiPaper-root .customModalBg li {
        color: #111 !important;
        line-height: 1.25 !important;
        text-align: left !important;
      }

      .MuiPaper-root .customModalBg ul,
      .MuiPaper-root .customModalBg ol {
        box-sizing: border-box !important;
        width: 100% !important;
        margin-right: 0 !important;
        margin-left: 0 !important;
      }

      .MuiPaper-root .MuiInputBase-root,
      .MuiPaper-root .MuiOutlinedInput-notchedOutline {
        border-color: #111 !important;
        border-radius: 0 !important;
      }

      .MuiPaper-root .MuiInputBase-root,
      .MuiPaper-root .MuiButton-root {
        display: flex !important;
        box-sizing: border-box !important;
        width: 100% !important;
        margin-right: 0 !important;
        margin-left: 0 !important;
      }

      .MuiPaper-root .MuiInputBase-root {
        height: calc(40 * var(--vh-popup-unit)) !important;
        min-height: 0 !important;
        border: 1px solid #111 !important;
        background: #fff !important;
      }

      .MuiPaper-root .MuiInputBase-input {
        box-sizing: border-box !important;
        height: 100% !important;
        padding: 0 calc(12 * var(--vh-popup-unit)) !important;
      }

      .MuiPaper-root .MuiInputLabel-root {
        left: calc(12 * var(--vh-popup-unit)) !important;
        top: 50% !important;
        transform: translateY(-50%) !important;
        font-size: calc(12 * var(--vh-popup-unit)) !important;
      }

      .MuiPaper-root .MuiInputLabel-root[data-shrink="true"] {
        top: 0 !important;
        transform: translateY(-50%) scale(0.75) !important;
        background: #fff !important;
      }

      .MuiPaper-root .MuiFilledInput-root::before,
      .MuiPaper-root .MuiFilledInput-root::after {
        border: 0 !important;
      }

      .MuiPaper-root .MuiButton-root {
        height: calc(42 * var(--vh-popup-unit)) !important;
        min-height: 0 !important;
        padding: 0 !important;
        font-size: calc(12 * var(--vh-popup-unit)) !important;
        border: 0 !important;
        border-radius: 0 !important;
        background: #000 !important;
        color: #fff !important;
        text-transform: none !important;
        letter-spacing: 0 !important;
      }
    }
  `;

  const mobileStyles = `
    @media (max-width: 767px) {
      .MuiDialog-container {
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
        box-sizing: border-box !important;
        height: 100dvh !important;
        min-height: 100dvh !important;
      }

      .MuiPaper-root {
        box-sizing: border-box !important;
        width: calc(100vw - 30px) !important;
        max-width: 560px !important;
        max-height: 90dvh !important;
        margin-top: 0 !important;
        margin-bottom: 0 !important;
        overflow-y: auto !important;
        border-radius: 0 !important;
      }

      .MuiPaper-root .MuiDialogTitle-root {
        position: absolute !important;
        top: auto !important;
        right: 0 !important;
        left: 0 !important;
        bottom: 0 !important;
        z-index: 1000 !important;
        box-sizing: border-box !important;
        height: 0 !important;
        flex: 0 0 0 !important;
        padding: 0 !important;
        overflow: visible !important;
        pointer-events: none !important;
      }

      .MuiPaper-root .MuiDialogTitle-root .MuiIconButton-root {
        position: absolute !important;
        top: auto !important;
        right: auto !important;
        bottom: 6px !important;
        left: 50% !important;
        z-index: 1001 !important;
        width: 44px !important;
        height: 44px !important;
        padding: 0 !important;
        border: 0 !important;
        border-radius: 50% !important;
        transform: translateX(-50%) !important;
        background: transparent !important;
        color: #a6a6a6 !important;
        pointer-events: auto !important;
        touch-action: manipulation !important;
        cursor: pointer !important;
      }

      .MuiPaper-root .MuiDialogTitle-root .MuiIconButton-root::before {
        content: "";
        position: absolute;
        inset: 7px;
        box-sizing: border-box;
        border: 1px solid #a6a6a6;
        border-radius: 50%;
        background: #fff;
        pointer-events: none;
      }

      .MuiPaper-root .MuiDialogTitle-root .MuiIconButton-root svg {
        position: relative !important;
        width: 16px !important;
        height: 16px !important;
        stroke-width: 1.25 !important;
      }

      .MuiPaper-root .customModalBg:has(.MuiButton-root) {
        box-sizing: border-box !important;
        padding-bottom: 56px !important;
      }

      .MuiPaper-root .customModalBg {
        box-sizing: border-box !important;
        padding-top: 12px !important;
        padding-right: 12px !important;
        padding-left: 12px !important;
      }

      .MuiPaper-root .customModalBg div:has(> span[style*="margin-bottom"]) {
        box-sizing: border-box !important;
        width: 100% !important;
        margin: 0 !important;
        padding: 0 !important;
      }

      .MuiPaper-root .customModalBg div:has(> span[style*="margin-bottom"])::before {
        content: "";
        display: block;
        width: 100%;
        height: min(65vw, 300px);
        margin: 0 0 12px;
        background: ${layoutImageCss} center / cover no-repeat;
      }

      .MuiPaper-root .customModalBg div:has(> span[style*="margin-bottom"]) > span {
        color: #111 !important;
        font-size: clamp(14px, 4.1vw, 18px) !important;
        font-weight: 400 !important;
        line-height: 1.125 !important;
        letter-spacing: -0.01em !important;
        text-align: left !important;
        white-space: nowrap !important;
      }

      .MuiPaper-root .customModalBg span[style*="white-space: pre-line"]:not([style*="margin-bottom"]) {
        display: block !important;
        box-sizing: border-box !important;
        width: 100% !important;
        margin-right: 0 !important;
        margin-left: 0 !important;
        font-size: clamp(10px, 3vw, 13px) !important;
        line-height: 1.125 !important;
        letter-spacing: -0.02em !important;
        /* Keep AfterShip's configured line breaks without wrapping the intro. */
        white-space: pre !important;
      }

      .MuiPaper-root .MuiTypography-root {
        color: #111 !important;
        line-height: 1.125 !important;
        text-align: left !important;
      }

      .MuiPaper-root .customModalBg li {
        line-height: 1.125 !important;
      }

      .MuiPaper-root .customModalBg ul,
      .MuiPaper-root .customModalBg ol {
        box-sizing: border-box !important;
        width: 100% !important;
        margin-right: 0 !important;
        margin-left: 0 !important;
      }

      .MuiPaper-root .MuiInputBase-root,
      .MuiPaper-root .MuiOutlinedInput-notchedOutline {
        border-color: #111 !important;
        border-radius: 0 !important;
      }

      .MuiPaper-root .MuiInputBase-root,
      .MuiPaper-root .MuiButton-root {
        display: flex !important;
        box-sizing: border-box !important;
        width: 100% !important;
        margin-right: 0 !important;
        margin-left: 0 !important;
      }

      .MuiPaper-root .MuiButton-root {
        min-height: 54px !important;
        border: 0 !important;
        border-radius: 0 !important;
        background: #000 !important;
        color: #fff !important;
        text-transform: uppercase !important;
        letter-spacing: 0.08em !important;
      }
    }
  `;

  function applyDesktopSize(frameDocument) {
    const frameView = frameDocument.defaultView;
    const paper = frameDocument.querySelector('.MuiPaper-root');
    if (!frameView || !paper) return;

    const viewportWidth = frameDocument.documentElement.clientWidth || frameView.innerWidth;
    const viewportHeight = frameDocument.documentElement.clientHeight || frameView.innerHeight;

    if (viewportWidth < 768) {
      const originalSize = originalDialogSizes.get(paper);
      if (!originalSize) return;
      if (originalSize.width) {
        paper.style.setProperty('width', originalSize.width, originalSize.widthPriority);
      } else {
        paper.style.removeProperty('width');
      }
      if (originalSize.height) {
        paper.style.setProperty('height', originalSize.height, originalSize.heightPriority);
      } else {
        paper.style.removeProperty('height');
      }
      originalDialogSizes.delete(paper);
      return;
    }

    if (!originalDialogSizes.has(paper)) {
      originalDialogSizes.set(paper, {
        width: paper.style.getPropertyValue('width'),
        widthPriority: paper.style.getPropertyPriority('width'),
        height: paper.style.getPropertyValue('height'),
        heightPriority: paper.style.getPropertyPriority('height')
      });
    }

    const scale = Math.min(viewportWidth / 1920, viewportHeight / 919);
    if (!Number.isFinite(scale) || scale <= 0) return;

    const width = `${780 * scale}px`;
    const height = `${420 * scale}px`;
    if (paper.style.getPropertyValue('width') !== width ||
        paper.style.getPropertyPriority('width') !== 'important') {
      paper.style.setProperty('width', width, 'important');
    }
    if (paper.style.getPropertyValue('height') !== height ||
        paper.style.getPropertyPriority('height') !== 'important') {
      paper.style.setProperty('height', height, 'important');
    }
  }

  function addStyles(frame) {
    try {
      const frameDocument = frame.contentDocument;
      if (!frameDocument?.head) return;

      let style = frameDocument.getElementById(styleId);
      if (!style) {
        style = frameDocument.createElement('style');
        style.id = styleId;
        frameDocument.head.appendChild(style);
      }
      style.textContent = `${desktopStyles}\n${mobileStyles}`;
      applyDesktopSize(frameDocument);

      if (!observedDocuments.has(frameDocument)) {
        observedDocuments.add(frameDocument);
        frameDocument.defaultView?.addEventListener('resize', () => applyDesktopSize(frameDocument));
        const popupObserver = new MutationObserver(() => applyDesktopSize(frameDocument));
        popupObserver.observe(frameDocument.documentElement, {
          attributes: true,
          attributeFilter: ['style'],
          childList: true,
          subtree: true
        });
      }
    } catch {
      // If AfterShip moves this iframe to another origin, the theme stays usable.
    }
  }

  function attachFrame() {
    const frame = document.getElementById(frameId);
    if (!(frame instanceof HTMLIFrameElement) || observedFrames.has(frame)) return;

    const source = new URL(frame.src, window.location.href);
    if (source.origin !== window.location.origin ||
        source.pathname !== '/apps/automizely-messages/layers/popup-bars/') return;

    observedFrames.add(frame);
    frame.addEventListener('load', () => addStyles(frame));
    addStyles(frame);
  }

  const observer = new MutationObserver((mutations) => {
    if (mutations.some((mutation) => mutation.addedNodes.length)) attachFrame();
  });
  observer.observe(document.body, { childList: true, subtree: true });
  attachFrame();
})();
